import React from 'react';
import { observer } from 'mobx-react';
import { Catcher, LoadingApiByIds } from '../../';
import { VerticalUsageChart } from './';
import { useDashboardTimelineUsageChart } from '../../../hooks';
import { tP } from '../../../translate';
import Styles from '../m_dashboarStyles.less';

export const TimelineUsage: React.FC = observer(() => {
    const data = useDashboardTimelineUsageChart();

    return (
        <Catcher>
            <LoadingApiByIds idSpinners={['GET_USAGE_TIMELINE_LIST']} />
            <div className={Styles.chart}>
                <VerticalUsageChart sourceData={data} title={tP('Usage last months')} />
            </div>
        </Catcher>
    );
});
